// --------------------------------------------------------------------
//***** Bundle container = SUMTRACKER + GLOBO bundle parent setup
// --------------------------------------------------------------------
// Save + Restore Globo selections (child PDP only)
document.addEventListener("DOMContentLoaded", () => {
  const parentFlag = document.getElementById("bundle-parent-flag");
  if (parentFlag) return; // stop if PARENT — run only on CHILD

  // Find parent handle stored in metafield on child
  const parentHandle = document.body.dataset.bundleParent;
  if (!parentHandle) return;

  const storageKey = `gpoSelections_${parentHandle}`;

  function saveGPOData() {
    const data = {};
    const fields = document.querySelectorAll(".gpo-element input, .gpo-element textarea, .gpo-element select");

    fields.forEach(el => {
      if ((el.type === "radio" || el.type === "checkbox") && !el.checked) return;
      if (el.value && el.value.trim() !== "") data[el.name] = el.value;
    });

    localStorage.setItem(storageKey, JSON.stringify(data));
  }

  function restoreGPOData() {
    const stored = localStorage.getItem(storageKey);
    if (!stored) return;

    const data = JSON.parse(stored);

    Object.keys(data).forEach(name => {
      const inputs = document.querySelectorAll(`[name="${CSS.escape(name)}"]`);
      const val = data[name];

      inputs.forEach(el => {
        if (el.type === "radio" || el.type === "checkbox") {
          if (el.value === val) el.checked = true;
        } else {
          el.value = val;
        }

        el.dispatchEvent(new Event("input", { bubbles: true }));
        el.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  // Watch for GPO to load
  const observer = new MutationObserver(() => {
    if (document.querySelector(".gpo-element")) {
      restoreGPOData();

      document.querySelectorAll(".gpo-element input, .gpo-element textarea, .gpo-element select")
        .forEach(el => {
          el.addEventListener("input", saveGPOData);
          el.addEventListener("change", saveGPOData);
        });

      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Clear stored config when child successfully adds to cart
  document.querySelectorAll(`button[name="add"]`).forEach(btn => {
    btn.addEventListener("click", () => localStorage.removeItem(storageKey), { once: true });
  });
});
// --------------------------------------------------------------------